import { subject } from "@casl/ability";
import {
  type CrudList,
  NetworkClient,
  type PastaApiListParams,
  useClassFactory,
  useNetworkService,
} from "@pasta/box-v2";
import { omit } from "lodash";
import { type LetterFileCCUserDto, type WriteLetterFileCCUserDto } from "../dto/letter-file-cc-user.dto";

export interface ListCCUsersParams extends PastaApiListParams {
  letterFileId: number;
}

export class LetterFileCCUserApi {
  getBaseEndpoint(letterFileId: number) {
    return `letter-file/${letterFileId}/cc-user/`;
  }

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  map(entity: LetterFileCCUserDto) {
    return subject("LetterFileCCUser", entity);
  }

  async getMany(lfId: number): Promise<CrudList<LetterFileCCUserDto>> {
    const response = await this.network.get<CrudList<LetterFileCCUserDto>>(this.getBaseEndpoint(lfId), {
      join: "author",
    });
    const list = response.data;
    list.data = list.data.map(this.map.bind(this));
    return list;
  }

  async create(dto: WriteLetterFileCCUserDto): Promise<LetterFileCCUserDto> {
    const response = await this.network.post(`${this.getBaseEndpoint(dto.letterFile)}`, omit(dto, "letterFile"));
    return this.map(response.data);
  }

  async delete(id: number, letterFileId: number) {
    await this.network.delete(`${this.getBaseEndpoint(letterFileId)}${id}`);
  }
}

export const [letterFileCCUserApiToken, useLetterFileCCUserApi] = useClassFactory(LetterFileCCUserApi);
